<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section mb-3">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Send Message</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div>
                <div class="font-bold mb-1">Sample Scripts</div>
                <div class="text-sm mb-2">
                  Customer service scripts for you to modify and send
                </div>
                <Dropdown
                  class="w-full"
                  optionLabel="label"
                  optionValue="value"
                  :showClear="true"
                  v-model="formData.service_script"
                  :options="app.menus.customerServiceScriptsItems"
                  label="Select sample script ... "
                  placeholder="Select sample script ... "
                  @change="loadScriptToMessageBox"
                />
                <hr />
              </div>
              <div class="">
                <div>
                  <form
                    ref="observer"
                    tag="form"
                    @submit.prevent="submitForm()"
                    class=""
                    :class="{ card: !isSubPage }"
                  >
                    <div class="grid">
                      <div class="col-12 md:col-12">
                        <div class="mb-2 font-bold text-sm">Message *</div>
                        <div id="ctrl-message-holder">
                          <Textarea
                            :class="getErrorClass('message')"
                            class="w-full"
                            ref="ctrlmessage"
                            rows="5"
                            v-model="formData.message"
                            placeholder="Type message here ..."
                            type="textarea"
                          >
                          </Textarea>
                          <small
                            v-if="isFieldValid('message')"
                            class="p-error"
                            >{{ getFieldError("message") }}</small
                          >
                        </div>
                        <div class="text-gray-400 text-sm py-2">
                          Note: Message will be sent as Push Notification to
                          customer if this complaint is linked to customer's
                          Mobile App account or customer has the Mobile App installed.
                        </div>
                      </div>
                    </div>
                    <div v-if="showSubmitButton" class="text-center my-3">
                      <Button
                        class="p-button-primary"
                        type="submit"
                        label="Submit"
                        icon="pi pi-send"
                        :loading="saving"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted, watch } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useAuth } from "@/composables/auth";
import { useAddPage } from "@/composables/addpage.js";
import { useRoute } from "vue-router";
const props = defineProps({
  pageName: {
    type: String,
    default: "chats",
  },
  routeName: {
    type: String,
    default: "chatsadd",
  },
  apiPath: {
    type: String,
    default: "chats/add",
  },
  submitButtonLabel: {
    type: String,
    default: "Submit",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterSave: {
    type: String,
    default: "Record added successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
  pageData: {
    // use to set formData default values from another page
    type: Object,
    default: () => {},
  },
});
const app = useApp();
const auth = useAuth();
const route = useRoute();
const formDefaultValues = {
  service_script: "",
  complaint_id: "",
  message: "",
};
const formData = reactive({ ...formDefaultValues });
//form validation rules
const rules = computed(() => {
  return {
    message: { required },
  };
});
const v$ = useVuelidate(rules, formData); // form validation
const page = useAddPage({ props, formData, v$, beforeSubmit, afterSubmit });
// perform custom validation before submit form
// set custom form fields
// return false if validation fails
function beforeSubmit() {
  return true;
}
// after form submited to api
// reset form data.
// redirect to another page
function afterSubmit(response) {
  app.flashMsg(props.msgAfterSave);
  page.setFormDefaultValues(); //reset form data
  //   if (props.redirect) app.navigateTo(`/chats`);
}
//page state
const {
  submitted, // form submitted state - Boolean
  saving, // form api submiting state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page methods
const {
  submitForm, //submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;

function loadScriptToMessageBox() {
  Object.assign(formData, {
    message: formData.service_script
      .toString()
      .replace(/\<CustomerName\>/g, props.pageData.customer_name)
      .replace(/\<YourName\>/g, auth.userFirstName),
  });
}

onMounted(() => {
  const pageTitle = "New Message";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title

  const id = props.pageData.complaint_id;
  Object.assign(formData, { complaint_id: id });
});
// expose page object for other components access
defineExpose({
  page,
});
</script>
<style scoped></style>
